import { useCallback, useEffect, useState } from "react";
import Tabela from "../../../Componentes/Utils/Tabela"
import styled from "styled-components";
import { useModal } from "../../../contexts/ModalContext";
import ModalConteudo from "./ModalConteudo";
import GenericHeader from "../../../Componentes/GenericHeader";
import Filters from "../../../Componentes/Utils/Filters";
import FilterContainer from "../../../Componentes/Utils/FilterContainer";

import useApi from "../../../hooks/useApi";
const ColunaCentralizada = styled.td`
    text-align: center !important;
`

const StatusDot = styled.span`
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.4);
    background-color: ${props => props.status ? "green" : "red"};
`

const ConteudoFuncaoOs = () => {
    const api = useApi();


    const { openModal, closeModal, isModalOpen } = useModal();

    const [ dados, setDados ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const [ error, setError ] = useState(null);

    const fetchDados = async () => {

        setLoading(true);
        setError(null);

        try{

            const { data } = await api.get("/Painel/API/Treinamentos/FuncaoOs/", { withCredentials: true });
            console.log(data);
            setDados(data);

        }catch( e ){

            console.error("Erro ao buscar dados:", e);
            setError("Não foi possível carregar os dados. Tente novamente mais tarde.");

        }finally{

            setLoading(false);

        }

    }

    useEffect(() => {
        fetchDados();
    }, []);

    const [ selectedFuncao, setSelectedFuncao ] = useState(null);

    const handleOpenModal = (funcao) => {

        setSelectedFuncao(funcao);
        openModal("conteudoOs");

    }

    const handleCloseModal = () => {

        setSelectedFuncao(null);
        closeModal();

    }

    const [ filtroFuncao, setFiltroFuncao ] = useState("");
    const [ filtroQuantidade, setFiltroQuantidade ] = useState([]);
    const [ filtroConteudo, setFiltroConteudo ] = useState([]);
    const [ dadosFiltrados, setDadosFiltrados ] = useState([]);

    const handleFilter = useCallback(() => {
        setDadosFiltrados(
            dados.filter(item => {
                const funcaoOk = !filtroFuncao || item.funcao.toLowerCase().includes(filtroFuncao.toLowerCase());
    
                const quantidadeOk =
                    !filtroQuantidade.length ||
                    ( filtroQuantidade.some( obj => obj.value === "com" ) && item.quantidade > 0 ) ||
                    ( filtroQuantidade.some( obj => obj.value === "sem" ) && item.quantidade === 0 );
    
                const conteudoOk =
                    !filtroConteudo.length ||
                    (filtroConteudo.some( obj => obj.value === "com" ) && item.conteudo > 0 ) ||
                    (filtroConteudo.some( obj => obj.value === "sem" ) && item.conteudo === 0 );
    
                return funcaoOk && quantidadeOk && conteudoOk;
            })
        );
    }, [dados, filtroFuncao, filtroQuantidade, filtroConteudo]);

    useEffect(() => {

        handleFilter()

    }, [ handleFilter ])

    return(
        <>
            <GenericHeader>
                <Filters columns={ 3 } >
                    <FilterContainer
                        type="text"
                        placeholder="FUNÇÃO..."
                        changeFunc={ (valor) => setFiltroFuncao( valor ) }
                    />
                    <FilterContainer
                        type="select"
                        placeholder="COLABORADORES..."
                        options={[{ value: "com", label: "COM COLABORADORES" }, { value: "sem", label: "SEM COLABORADORES" }]}
                        changeFunc={ setFiltroQuantidade }
                    />
                    <FilterContainer
                        type="select"
                        placeholder="CONTEÚDO..."
                        options={[{ value: "com", label: "COM CONTEÚDO" }, { value: "sem", label: "SEM CONTEÚDO" }]}
                        changeFunc={ setFiltroConteudo }
                    />
                </Filters>
            </GenericHeader>
            <Tabela loading={ loading } >
                <thead>
                    <tr>
                        <th>FUNÇÃO</th>
                        <th>COLABORADORES ATIVOS</th>
                        <th>CONTEÚDO</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        dadosFiltrados.map(( item, index ) => (
                            <tr key={ index }  onClick={() => handleOpenModal(item.funcao)}>
                                <td>{ item.funcao }</td>
                                <ColunaCentralizada>{ item.quantidade > 0 ? `SIM (${ item.quantidade })` : "NÃO" }</ColunaCentralizada>
                                <ColunaCentralizada>
                                    <StatusDot status={ item.conteudo } />
                                </ColunaCentralizada>
                            </tr>
                        ))
                    }
                </tbody>
            </Tabela>
            {
                isModalOpen("conteudoOs") && (
                    <ModalConteudo funcao={ selectedFuncao } onClose={ handleCloseModal } />
                )
            }
        </>
    )
}
export default ConteudoFuncaoOs;